import {
  ApplicationModuleRatePlanFormDto,
  type ApplicationModuleRatePlanFormInterface,
} from '@zaoblako/shared/modules/security/dtos/application/module/application-module-rate-plan-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { APPLICATION_MODULES } from '@zaoblako/shared/modules/security/constants/application-access-control.constants';

/** Application access control settings request body for rate plan create/update APIs - DTO signature */
export type ApplicationAccessControlRatePlanFormInterface = Record<string, ApplicationModuleRatePlanFormInterface>;

/** Application access control settings request body for rate plan create/update APIs - DTO schema */
export const ApplicationAccessControlRatePlanFormDto = SerdeDtoClass.create<ApplicationAccessControlRatePlanFormInterface>(
  SecurityDtoKeysEnum.APPLICATION_ACCESS_CONTROL_RATE_PLAN_FORM_DTO,
  Object.fromEntries(
    Object
      .entries(APPLICATION_MODULES)
      .map(([systemName, module]) => [
        systemName,
        {
          label: module.displayName,
          nested: ApplicationModuleRatePlanFormDto,
          serializer: (_, nested): any => nested,
        },
      ]),
  ),
);
